import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import image from "_assets/images/PRM-Logo-PNG/flying-airplanes.png";

const AnimatedAirplanes = () => {
    return (
        <>
          <Container>
            <Row>
              <div>
                <img
                  src={image}
                />
              </div>
            </Row>
          </Container>      
        </>
    );
};

export default AnimatedAirplanes;
